module.exports = __webpack_public_path__ + "static/media/sf_attraction_sci.f267f2e7.jpg";